export default __webpack_public_path__ + "static/media/logo-imss.ece6edf7.svg";